import { WorkSheet } from 'xlsx';
import { Formik, FormikProps } from 'formik';
import SpreadsheetSteps from './SpreadsheetSteps';
import { AsyncCatalogAssociation } from 'src/app/api/openapi';
import { useParams } from 'react-router-dom';
import { CatalogProductsClient } from 'src/app/api/clients/catalogProducts';
import { useRef } from 'react';

export interface AddFromSpreadsheetFormValues {
  activeStep: number;
  spreadsheet: WorkSheet | null;
  products: object[];
}

const AddProductsFromSpreadsheet = () => {
  const { merchantId, catalogId } = useParams();
  const formikRef = useRef<FormikProps<AddFromSpreadsheetFormValues>>(null);

  const handleAddProducts = (values: AddFromSpreadsheetFormValues) => {
    if (!merchantId || !catalogId) return; // @ts-ignore
    const formattedPayload: AsyncCatalogAssociation[] = values.products.map(
      (product: any) => ({
        gtin: `${product.sku}`,
        title: product.title || null,
        description: product.description || null,
        // categories: product.categories
        price: product.price
          ? { amount: `${product.price}`, currency_code: 'USD' }
          : null,
      })
    );
    CatalogProductsClient.queueProductsToCatalog(
      merchantId,
      catalogId,
      formattedPayload
    )
      .then(() => formikRef.current?.setFieldValue('activeStep', 3))
      .catch(() => alert('Failed to add products to catalog. Try again.'));
  };

  return (
    <Formik
      initialValues={
        {
          activeStep: 0,
          spreadsheet: null,
          products: [],
        } as AddFromSpreadsheetFormValues
      }
      onSubmit={handleAddProducts}
      innerRef={formikRef}
    >
      {SpreadsheetSteps}
    </Formik>
  );
};

export default AddProductsFromSpreadsheet;
